import type {ReactElement, ReactNode} from 'react';
import {aiChatCallbacksContext, NO_AI_CHAT_CALLBACKS} from '@AiChat/callbacks/ai-chat-callbacks.context';
import type {AiChatCallbacks} from '@AiChat/callbacks/ai-chat-callbacks.types';

export interface AiChatCallbacksProviderProps {
  callbacks?: AiChatCallbacks;
  children: ReactNode;
}

export function AiChatCallbacksProvider({callbacks, children}: AiChatCallbacksProviderProps): ReactElement {
  return <aiChatCallbacksContext.Provider value={callbacks ?? NO_AI_CHAT_CALLBACKS}>{children}</aiChatCallbacksContext.Provider>;
}
